import React, { Component, Fragment } from "react";
import "moment/locale/fr";

import List from "../../../components/list/List";
import Pagination from "components/pagination/Pagination";
import propertiesListColumn from "./PropertiesList.utils";

class PropertiesList extends Component {
  componentDidMount() {
    this.props.init("properties");
  }

  render() {
    const { propertiesList, page, pages, pageSize, nbItems, getNext } = this.props;

    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des propriétés</h2>
        </div>
        <div class="p-content-page-center-content">
          <List columns={propertiesListColumn} data={propertiesList} defaultText="Aucune propriété trouvée." />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>{" "}
        </div>{" "}
      </div>
    );
  }
}

export default PropertiesList;



// WEBPACK FOOTER //
// src/containers/admin/properties/PropertiesList.js